import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

type TAppSlug = 
  | 'teeon' 
  | 'golfnorth' 
  | 'rivershore'
  | 'tuscarora'
  | 'crumlincreek'
;

type TAppStoreLinksConfig = {
  label: string;
  ios: string;
  android: string;
  redirectUrl: string;
}

const APP_STORE_LINKS: Record<TAppSlug, TAppStoreLinksConfig> = {
  teeon: {
    label: 'Tee-on',
    ios:     'https://apps.apple.com/app/id6476159748',
    android: 'https://play.google.com/store/apps/details?id=com.teeon',
    redirectUrl: 'https://teeon.com',
  },
  golfnorth: {
    label: 'Golfnorth',
    ios:     'https://apps.apple.com/app/id6670619595',
    android: 'https://play.google.com/store/apps/details?id=com.teeon.golfnorth',
    redirectUrl: 'https://golfnorth.ca',
  },
  rivershore: {
    label: 'Rivershore',
    ios:     'https://apps.apple.com/app/id6752861224',
    android: 'https://play.google.com/store/apps/details?id=com.teeon.rivershore',
    redirectUrl: 'https://rivershoregolflinks.com/',
  },
  tuscarora: {
    label: 'Tuscarora',
    ios:     'https://apps.apple.com/app/id6759293360',
    android: 'https://play.google.com/store/apps/details?id=com.teeon.tuscarora',
    redirectUrl: 'https://tuscaroragolfclub.com/',
  },
  crumlincreek: {
    label: 'Crumlin Creek',
    ios:     'https://apps.apple.com/app/id6759293201',
    android: 'https://play.google.com/store/apps/details?id=com.teeon.crumlincreek',
    redirectUrl: 'https://crumlincreek.com/',
  },
};

const FALLBACK_URL = 'https://www.teeon.com';

export default function AppStoreRedirect() {
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string }>();
  const links = slug ? APP_STORE_LINKS[slug as keyof typeof APP_STORE_LINKS] : null;

  useEffect(() => {
    // Slug not set up, fallback to teeon.com
    if (!links) {
      window.location.replace(FALLBACK_URL);
      return;
    }

    // Slug link found, but store URL is not found (ie. laptops)
    const url = getStoreUrl(links) ?? links.redirectUrl;
    window.location.replace(url);
  }, [links]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>{t(`Redirecting to the {{client}} app..`, { client: links?.label ?? slug })}</p>
    </div>
  );
}

function getStoreUrl(links: { ios: string, android: string }) {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) {
    return links.android;
  }
  if (/iphone|ipad|ipod/i.test(ua)) {
    return links.ios;
  }
  return null;
}